import { ColorType } from './type'

export const lightColor: ColorType = {
  bgGray: 'rgba(242,243,245,1)',
  bg: 'rgba(255,255,255,1)',
  bg2: 'rgba(242, 243, 245, 1)',
  bgLightGray: 'rgba(249,249,250,1)',
  bgPopup: 'rgba(0,0,0,0.600)',
  primary10: 'rgba(233,250,207,1)',
  primary20: 'rgba(206,255,127,1)',
  primary30: 'rgba(142,205,30,1)',
  primary40: 'rgba(83,130,0,1)',
  primary50: 'rgba(219,237,210,1)',
  primaryGreyGreen: 'rgba(160,198,142,1)',
  textHighlight: 'rgba(37,99,235,1)',
  text00: 'rgba(255,255,255,1)',
  text10: 'rgba(227,229,235,1)',
  text20: 'rgba(200,203,215,1)',
  text30: 'rgba(173,177,195,1)',
  text40: 'rgba(145,151,176,1)',
  text50: 'rgba(118,126,156,1)',
  text60: 'rgba(90,102,137,1)',
  text70: 'rgba(71,77,101,1)',
  text80: 'rgba(51,55,67,1)',
  text90: 'rgba(32,33,33,1)',
  text100: 'rgba(7,7,7,1)',
  buy10: 'rgba(232,252,241,1)',
  buy20: 'rgba(165,225,191,1)',
  buy30: 'rgba(101,186,119,1)',
  buy40: 'rgba(65,158,106,1)',
  buy50: 'rgba(8, 202, 125, 1)',
  buy60: 'rgba(14, 203, 129, 0.9)',
  buy70: 'rgba(232, 252, 241, 1)',
  sell10: 'rgba(255,235,235,1)',
  sell20: 'rgba(252,149,149,1)',
  sell30: 'rgba(227,85,97,1)',
  sell40: 'rgba(176,18,18,1)',
  sell50: 'rgba(246, 70, 93, 1)',
  sell60: 'rgba(245, 69, 93, 0.9)',
  sell70: 'rgba(255, 235, 235, 1)',
  notificationBlue01: 'rgba(230,239,250,1)',
  notificationBlue02: 'rgba(0,108,229,1)',
  notificationGreen01: 'rgba(232,252,241,1)',
  notificationGreen02: 'rgba(65,158,106,1)',
  notificationRed01: 'rgba(255,235,235,1)',
  notificationRed02: 'rgba(216,50,50,1)',
  notificationYellow01: 'rgba(254,247,234,1)',
  notificationYellow02: 'rgba(238,149,0,1)',
  notificationPurple01: 'rgba(242, 234, 254, 1)',
  notificationPurple02: 'rgba(105, 0, 238, 1)',

  borderLayout: 'rgba(227,229,235,1)',

  bgMask: 'rgba(0, 0, 0, 0.16)',
  bgHistoryTabs: 'rgba(233,250,207,1)',
  bgNavButton: 'rgba(242,243,245,1)',
  networkSelectionBgColor: 'rgba(233,250,207,1)',
  withdrawTypeBgColor: 'rgba(233,250,207,1)',
  TabHoverColor: 'rgba(206,255,127,1)',
  balanceGroupBorderColor: 'rgba(227,229,235,1)',
  balanceGroupHoverBgColor: 'rgba(242,243,245,1)',
  balanceGroupHoverBorderColor: 'rgba(200,203,215,1)',

  DatePickerInput: 'rgba(0, 0, 0, 0.23)',
  BoxBg01: 'rgba(249, 249, 250, 1)',
  BoxBg02: 'rgba(255, 255, 255, 1)',
  BoxBg03: 'rgba(249, 249, 250, 1)',
  BoxBg04: 'rgba(142, 205, 30, 1)',
  BoxBorder01: 'rgba(242, 243, 245, 1)',
  BoxLineBg: 'rgba(227, 229, 235, 1)',
  BoxBtnBg: 'rgba(227, 229, 235, 1)',
  BoxBtnBg02: 'rgba(142, 205, 30, 1)',
  BoxBtnColor: 'rgba(255, 255, 255, 1)',
  BoxRankBg01: 'rgba(244, 250, 232, 1)',
  BoxRankBorder01: 'rgba(142, 205, 30, 1)',
  BoxRankBg02: 'rgba(254, 255, 224, 1)',
  BoxRankBorder02: 'rgba(255, 215, 3, 1)',
  BoxRankBg03: 'rgba(239, 251, 248, 1)',
  BoxRankBorder03: 'rgba(3, 195, 255, 1)',
  BoxDialogBg: 'rgba(242, 243, 245, 1)',
  BoxDialogBg02: 'rgba(227, 229, 235, 1)',
  BoxHistoryRow: 'rgba(227, 229, 235, 1)',
}
